import { guideCollection } from '@/mocks/haijiao';

export default function GuideCollection() {
  return (
    <section id="guides" className="bg-background-100/60 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <p className="text-sm font-semibold tracking-widest text-accent-600">攻略 · 教程 · 合集</p>
            <h2 className="mt-3 font-heading text-3xl font-bold tracking-tight text-foreground-950 md:text-4xl">
              海角吃瓜攻略合集
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-600">
            每一册都是一次完整的话题拆解，从入门到进阶按需取用，篇篇有据、有图、有步骤。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {guideCollection.map((g) => (
            <article
              key={g.tag + g.title}
              className="group flex flex-col overflow-hidden rounded-2xl bg-background-50 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="relative aspect-[10/7] overflow-hidden bg-background-200">
                <img
                  src={g.cover}
                  alt={`海角吃瓜${g.title}`}
                  title={`海角吃瓜${g.title}`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-3 py-1 text-xs font-semibold text-foreground-800">
                  {g.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5 md:p-6">
                <h3 className="font-heading text-lg font-semibold leading-snug text-foreground-950">
                  <a href="#guides" className="transition-colors group-hover:text-primary-700">
                    {g.title}
                  </a>
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{g.desc}</p>
                <div className="mt-auto flex items-center justify-between pt-5 text-sm">
                  <span className="flex items-center gap-1.5 text-foreground-400">
                    <i className="ri-time-line"></i>
                    {g.read}
                  </span>
                  <a
                    href="#guides"
                    className="inline-flex items-center gap-1 font-semibold text-primary-600 transition-colors hover:text-primary-700 whitespace-nowrap"
                  >
                    打开攻略
                    <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}